export default __webpack_public_path__ + "static/media/ydragon.f3b1854c.jpeg";